/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';

const AddVideoTrimData = data => {
  return new Promise(function request(resolve, reject) {
    maverickPortalhttp
      .makeRequestWithoutBase(
        maverickPortalApiEndPoint.videoTrim.url, 
        maverickPortalApiEndPoint.videoTrim.methodType, 
        data)
      .then(response => {
        const res = response.data;
        resolve({ res });
      })
      .catch(error => {
        // Handle error response
        const errorResponse = error.response?.data || error.message || 'API request failed';
        resolve({ res: error.response?.data || errorResponse });
      });
  });
};

export { AddVideoTrimData };
